// extracted by mini-css-extract-plugin
export default {"separator":"accordions_separator__SMBuA","subtitle":"accordions_subtitle__vkadl"};